import { PublicServiceMeta } from '@/lib/models/public-service';
import { TileModel } from '@/lib/models/user-settings/tile.model';
import { createContext } from 'react';

export interface HomeSettings {
  publicServices: PublicServiceMeta[];
  publicServiceTiles: TileModel[];
  tiles: TileModel[];
  favorites: TileModel[];
  recent: TileModel[];
  hasFavorites: boolean;
  hasRecent: boolean;
  hasAgents: boolean;
  hasServices: boolean;
  isLoading: boolean;
}

export const HomeContext = createContext<HomeSettings>({
  publicServices: [],
  publicServiceTiles: [],
  tiles: [],
  favorites: [],
  hasFavorites: false,
  recent: [],
  hasRecent: false,
  hasAgents: false,
  hasServices: false,
  isLoading: false,
});
